import { keys } from './environment.types'
import { readFullEnv } from './utils'

export function readFromEnv(key: keys) {
  const fullEnv = readFullEnv()

  const envValue = fullEnv[key]

  if (envValue === undefined || envValue === null) {
    throw new Error(`
        Missing environment variable value for key ${key}.
        Running locally: Do you have a .env.local file in your app folder that contains ${key}?
        Running in CI: Is ${key} exposed in the CI pipeline file?
        `)
  }

  return envValue
}

export {
  Env,
  type keys,
  type IEnvironmentFromFile,
  type IEnvironment,
} from './environment.types'
export { readFullEnv } from './utils'
